import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <div className="header"> 
      <div className="header-img">
        <img
          src="https://clarusway.com/wp-content/uploads/2022/12/clarusway-logo-black.png"
          alt=""
          srcset=""
         
        />
      </div><div  className="title"><h1>LESSON REMİNDER</h1></div>
      
    </div>
  );
};

export default Header;
